import Rest from '@/services/Rest';

/**
 * @typedef {RedirectService}
 */
export default class RedirectService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/redirect'
}
